import { ComponentType } from "react";

import { LiteListFrameGeneralAttributeComponentProps } from "../../../../components";
import { LLFAbstractRenderer } from "../../../../components/LiteListFrame/LLFCustomization/renderers/attribute";
import { ParticipantTypeAttribute } from "./ParticipantTypeAttribute";

export class ParticipantTypeAttributeRenderer extends LLFAbstractRenderer {
    public override canRender(): boolean {
        return false; // Nepoužívá elementy atributů, stačí mít nastavený klíč v dataSource
    }

    public override get component(): ComponentType<LiteListFrameGeneralAttributeComponentProps> {
        return ParticipantTypeAttribute;
    }
}
